import React from 'react';
import cn from 'classnames';
import Image from 'next/legacy/image';
import { Button, Grid } from 'ht-styleguide';
/* Utils */
import { smoothScroll } from '../locationPage.utils';
/* Styles */
import styles from '../locationPage.module.scss';

type ContentBlockProps = {
  title: string;
  switchColumns?: boolean;
  serviceImage: string;
  cityDescriptions: React.ReactNode;
  showButton?: boolean;
  imageProps?: {
    imageFit: string;
    imagePosition: string;
  };
};

const ContentBlock = ({ title, switchColumns = false, serviceImage, cityDescriptions, showButton = true }: ContentBlockProps) => {
  const contentTitle = title;
  const rowStyles = cn({
    [styles.columnReverse]: switchColumns,
  });
  const imagePosition = switchColumns ? 'center' : 'top';
  const imageFit = switchColumns ? 'cover' : 'contain';
  const showImage = switchColumns ? 0 : 'hidden';

  return (
    <Grid.FullWidth classes={cn('paddingY-huge1', styles.gridContainer)}>
      <Grid.Row classes={rowStyles}>
        <Grid.Column sm={showImage as number} lg={6} classes={styles.contentBlockImage}>
          <Image alt={contentTitle} quality={80} layout="fill" objectFit={imageFit} objectPosition={imagePosition} src={serviceImage} />
        </Grid.Column>
        <Grid.Column sm={4} mdOffset={1} lgOffset={1} md={6} lg={4} classes={switchColumns ? styles.customColumn : styles.columnMobile}>
          <h3 className="n900 paddingBottom-medium">{contentTitle}</h3>
          {cityDescriptions}
          {showButton && (
            <Grid.Row classes="paddingTop-small2">
              <Grid.Column classes={styles.contentBlockColumnStyles} sm={4} mdOffset={2} md={4} lgOffset={0} lg={12}>
                <Button onClick={smoothScroll} className={styles.button}>
                  Get a Price
                </Button>
              </Grid.Column>
            </Grid.Row>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid.FullWidth>
  );
};

export default ContentBlock;
